import React, { useRef } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import CommercialVehicleHeroSection from './CommercialVehicleHeroSection';
import CommercialVehicleBusinessSection from './CommercialVehicleBusinessSection';
import CommercialVehicleEmiSection from './CommercialVehicleEmiSection';
import CommercialVehicleChooseUsSection from './CommercialVehicleChooseUsSection';
import {useTranslation} from "react-i18next";
import usePageTitle from '../../hooks/usePageTitle';

const CommercialVehiclePage = () => {
    usePageTitle('page-title', 'commercialVehicleLoanPage');
    const heroRef = useRef(null);
    const handleClick = () => {
        heroRef.current?.scrollIntoView({behavior: 'smooth'});
    };
    const productType = "Commercial Vehicle Loan";
    const {t} = useTranslation('commercialVehicleLoanPage');
    const content = t('commercial-vehicle-choose-us-section-description');
    return (
        <>
            <Header/>
            <CommercialVehicleHeroSection ref={heroRef} onScrollToForm={handleClick}/>
            <CommercialVehicleBusinessSection/>
            {/* <CommercialVehicleEmiSection ref={heroRef} productType={productType}/> */}
            {/*<CommercialVehicleFormSection ref={heroRef} productType={productType}/>*/}
            <CommercialVehicleChooseUsSection content={content} onApplyNowClick={handleClick}/>
            <Footer/>
        </>
    );
}

export default CommercialVehiclePage;